
import { call, put, select, takeEvery } from 'redux-saga/effects'
import { getAuth } from '../../selectors/access/auth'
import getProcessingAgencyManagersCombo from '../../services/processingAgency/getProcessingAgencyManagersCombo'
import commonActions from '../../actions/common'
import messageModalActions from '../../actions/modals/messageModal'
import { fetchCombosSuccess } from '../../actions/combos/combos'
import combosActionTypes from '../../constants/actions/combos/combos'
import { handleError } from '../errors/errorManager'

export function * fetchProcessingAgencyManagersCombo ({ processingAgencyId }) {
  try {
    yield put(commonActions.showLoader())
    const auth = yield select(getAuth)
    let combo = yield call(getProcessingAgencyManagersCombo, auth.token, processingAgencyId)
    yield put(fetchCombosSuccess({ processingAgencyManagersCombo: combo }))
  } catch (error) {
    const sessionHandler = function * () {
    }
    const customHandler = function * () {
      yield put(messageModalActions.openErrorMessageModal('MESSAGES.FETCH_COMBO_ERROR'))
    }
    yield call(handleError, { error, customHandler, sessionHandler })
  } finally {
    yield put(commonActions.hideLoader())
  }
}

export function * watchFetchProcessingAgencyManagers () {
  yield takeEvery(combosActionTypes.FETCH_PROCESSING_AGENCY_MANAGERS_COMBO, fetchProcessingAgencyManagersCombo)
}
